<template>
    <v-row justify="center">
        <v-dialog v-model="isVisible" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$vuetify.lang.t('$vuetify.private_location.title')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <p>{{$vuetify.lang.t('$vuetify.private_location.body')}}</p>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.prevent="close(true)">{{$vuetify.lang.t('$vuetify.global.yes')}}</v-btn>
                    <v-btn color="green darken-1" text @click.prevent="close(false)">{{$vuetify.lang.t('$vuetify.global.no')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    name : "PrivateLocationCheckComponent",
    props : {
        isVisible : {
            type : Boolean,
            default : false
        }
    },
    methods : {
        close(isPrivate){
            this.$store.commit('setPrivateLocationState', isPrivate);
            this.$emit('checkComplete');
        }
    }
}
</script>